import { Component, OnInit } from '@angular/core';
import { CommonDataService } from '../../../common/services/common-data.service';
import { GraphqlService } from '../../../common/services/graphql.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { UtilityService } from '../../../common/services/utility-service';
import { constObj } from '../../../common/Constants/constants';
import { ConfirmDialogComponent } from '../../../common/shared-components/confirm-dialog/confirm-dialog.component';
import { SessionService } from '../../../common/services/Session.service';
import { LoginService } from '../../../common/services/Login.service';

@Component({
  selector: 'app-help-printing',
  templateUrl: './help-printing.component.html'
})
export class HelpPrintingComponent implements OnInit {

  constructor(
    public commonDataService: CommonDataService,
    private graphQlService: GraphqlService,
    private router: Router,
    public dialog: MatDialog,
    private utilityService: UtilityService,
    private session: SessionService,
    public loginService: LoginService) {
    this.isArchiveApplication();
  }
  archiveVersion: string = "";
  isArchive: boolean = false;
  help_printingHeader;
  help_printingDescription;
  help_printingDescriptionProView;
  help_printerFriendlyHeader;
  help_printerFriendlyDescription;
  help_printerTOCHeader;
  help_printerTOCDescription;
  help_printerSourcesHeader;
  help_printeSourcesDescription;
  help_browserSettingsHeader;
  help_browserSettingsDescription;
  userRole: string = "";

  ngOnInit(): void {
    this.checkSession();
    this.commonDataService.showLoader.next(true);
    this.gethelpprintinglabels();
  }
  ngOnDestroy() {
    this.commonDataService.loadCurrentLeftNav.next(null);
  }
 
  checkSession() {
    if (this.session.userInfo == undefined || this.session.userInfo.user == null) {
      this.loginService.getSession().subscribe(data => {
        this.session.assignUserInfo(data.user);
        this.userRole = data.user.roles;
      })
    }
    else { this.userRole = this.session.userInfo.user.roles; }
  }
  gethelpprintinglabels() {
    this.graphQlService.getHelpPrintingComponentLabel().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.help_printingHeader = labels.filter(x => x.key == "help_printingHeader").map(y => y.value);
        this.help_printingDescription = labels.filter(x => x.key == "help_printingDescription").map(y => y.value);
        this.help_printerFriendlyHeader = labels.filter(x => x.key == "help_printerFriendlyHeader").map(y => y.value);
        this.help_printerFriendlyDescription = labels.filter(x => x.key == "help_printerFriendlyDescription").map(y => y.value);
        this.help_printerTOCHeader = labels.filter(x => x.key == "help_printerTOCHeader").map(y => y.value);
        this.help_printerTOCDescription = labels.filter(x => x.key == "help_printerTOCDescription").map(y => y.value);
        this.help_printerSourcesHeader = labels.filter(x => x.key == "help_printerSourcesHeader").map(y => y.value);
        this.help_printeSourcesDescription = labels.filter(x => x.key == "help_printeSourcesDescription").map(y => y.value);
        this.help_browserSettingsHeader = labels.filter(x => x.key == "help_browserSettingsHeader").map(y => y.value);
        this.help_browserSettingsDescription = labels.filter(x => x.key == "help_browserSettingsDescription").map(y => y.value);
        this.help_printingDescriptionProView = labels.filter(x => x.key == "help_printingDescriptionProView").map(y => y.value);
        this.commonDataService.showLoader.next(false);
      }
    });
  }
  isArchiveApplication() {
    this.archiveVersion = localStorage.getItem("ArchiveVersion");
    if (localStorage.getItem("publicationId") != undefined && localStorage.getItem("currentVersionPublicationId") != localStorage.getItem("publicationId")) {
      this.archiveVersion = this.utilityService.convertMonthYear(localStorage.getItem("ArchiveVersion"));
      this.isArchive = Boolean(this.archiveVersion);
    }
    else if (this.router.url.split("/")[1] != localStorage.getItem("currentVersionPublicationId") && (this.archiveVersion != null && this.archiveVersion != undefined)) {
      this.archiveVersion = localStorage.getItem("ArchiveVersion");
      this.isArchive = Boolean(this.archiveVersion);
    }
    else { this.isArchive = false; }
  }
  BackToCurrentContent() {
    const PrintQueueSession = localStorage.getItem("SetPrintQueueSession");
    var printQueueCount: any = PrintQueueSession == "{}" ? 0 : PrintQueueSession == null ? 0 : PrintQueueSession == "" ? 0 : JSON.parse(localStorage.getItem("SetPrintQueueSession")).ParagraphIdsList.length;
    let popUpMessage = constObj.currentVersionNavigationAlert;
    if (printQueueCount > 0) {
      popUpMessage += "<br/>" + constObj.annotationAlertPrintQueue;
    }
    else { popUpMessage += "<br/>" + constObj.continueMessage; }
    localStorage.setItem("isConfirmPopup", "true");
    this.commonDataService.isConfirmationPopUpOpen.next(true);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '600px',
      data: popUpMessage
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      localStorage.removeItem("isConfirmPopup");
      if (result == true) {
        this.commonDataService.resetPrintQueue.next(true);
        this.commonDataService.printCount.next("toggleOff");
        this.commonDataService.printToggleOff.next("printToggleOff");
        localStorage.removeItem("ArchiveVersion");
        this.commonDataService.loadCurrentLeftNav.next(localStorage.getItem("currentVersionPublicationId"));
        this.router.navigateByUrl("/Home")
      }
    });
  }
}
